module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperDoubleThick-26215f5749989c6cd5d9a0629651bae4.jpg";